// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get } from "./api_client";
import { TargetType, FHWAClass, Lane, TurnType } from "../models";
import { Target, ITarget, TargetTrack, ITargetTrack, TargetResult, ITargetResult } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function getTargets(facilityId?: string, startTime?: number, endTime?: number): ApiResult<Target[]> {
	return get<ITarget[]>(`/api/facilitytarget/${ facilityId }/targets/${ startTime }/${ endTime }`).then(result => result === undefined ? undefined : result.map(o => new Target(o)));
}

export async function getRecentTracks(facilityId?: string, deviceId?: string, minutes?: number, maxTargets?: number, maxPointsPerTarget?: number): ApiResult<TargetTrack[]> {
		const queryParams = [deviceId !== undefined ? `deviceId=${deviceId}` : undefined,
			minutes !== undefined ? `minutes=${minutes}` : undefined,
			maxTargets !== undefined ? `maxTargets=${maxTargets}` : undefined,
			maxPointsPerTarget !== undefined ? `maxPointsPerTarget=${maxPointsPerTarget}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<ITargetTrack[]>(`/api/facilitytarget/${ facilityId }/recent-tracks${query}`).then(result => result === undefined ? undefined : result.map(o => new TargetTrack(o)));
}

export async function getByFacilityPaginated(facilityId?: string, limit?: number, sortKey?: string, sortDirection?: string, deviceId?: string, targetType?: TargetType, fHWAClass?: FHWAClass, lanes?: Lane, turnType?: TurnType, dateFrom?: Date, dateTo?: Date, cursor?: string): ApiResult<TargetResult> {
		const queryParams = [limit !== undefined ? `limit=${limit}` : undefined,
			sortKey !== undefined ? `sortKey=${sortKey}` : undefined,
			sortDirection !== undefined ? `sortDirection=${sortDirection}` : undefined,
			deviceId !== undefined ? `deviceId=${deviceId}` : undefined,
			targetType !== undefined ? `targetType=${targetType}` : undefined,
			fHWAClass !== undefined ? `fHWAClass=${fHWAClass}` : undefined,
			lanes !== undefined ? `lanes=${lanes}` : undefined,
			turnType !== undefined ? `turnType=${turnType}` : undefined,
			dateFrom !== undefined ? `dateFrom=${dateFrom.toISOString()}` : undefined,
			dateTo !== undefined ? `dateTo=${dateTo.toISOString()}` : undefined,
			cursor !== undefined ? `cursor=${cursor}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<ITargetResult>(`/api/facilitytarget/by_facility_paginated/${ facilityId }${query}`).then(result => result === undefined ? undefined :  new TargetResult(result));
}
